import React from 'react';
import Button from '../SelectValue/Button';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import WalletIcon from '@mui/icons-material/Wallet';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleIcon from '@mui/icons-material/People';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import { CheckCircleOutline, Dashboard, Group, TrendingUp } from '@mui/icons-material';

function Why() {
  const steps = [
    {
      icon: <Group fontSize="large" style={{ color: '#8046F2' }} />,
      title: 'Collective Power',
      description: 'When you save together, you unlock bigger opportunities than saving alone.',
      link: '/savings'
    },
    {
      icon: <TrendingUp fontSize="large" style={{ color: '#8046F2' }} />,
      title: 'Shared Growth',
      description: 'Your Circle’s pooled funds are invested in Shariah-compliant businesses and assets - so everyone earns.',
      link: '/investment'
    },
    {
      icon: <CheckCircleOutline fontSize="large" style={{ color: '#8046F2' }} />,
      title: '100% Halal',
      description: 'Every Circle is structured to follow Islamic finance principles: no riba, no uncertainty, no exploitation.',
      link: '/assetsfinancing'  
    },
    {
      icon: <Dashboard fontSize="large" style={{ color: '#8046F2' }} />,
      title: 'Transparent Returns',
      description: 'Track your contributions and profits in real-time with our easy-to-use dashboard.',
      link: '/circle'
    },
  ]; 

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, 
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <div className="px-6 sm:px-24 py-8 sm:py-16 mb-20">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-[24px] sm:text-[44px] font-[400]"
      >
        Why {' '}
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#FF75E8] to-[#8046F2]">
           Circles Work
        </span>
      </motion.h1>

      

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="mt-20 grid gap-6 sm:grid-cols-2 lg:grid-cols-4"
      >
        {steps.map((step, index) => (
          <motion.div
            key={index}
            variants={item}
            className="flex flex-col items-center p-4 rounded-lg bg-white shadow-md hover:shadow-lg transition-shadow"
          >
            <div
              className="w-12 h-12 mb-4 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#F5F1FE' }} 
            >
              {step.icon}
            </div>
            <h3 className="text-[16px] sm:text-[18px] font-[500] text-text-color1">
              {step.title}
            </h3>
            <p className="text-[12px] sm:text-[14px] font-[400] text-center text-text-color1 mt-2">
              {step.description}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

export default Why;
